import { Parametro } from 'portalba360';
import router from '../../router/index';

export const state = {
  one: {},
  all: [],
  parametro: new Parametro()
};

export const getters = {
  one: state => state.one,
  all: state => state.all
};

export const mutations = {
  setOne: (state, data)=>{
    state.one = data
  },
  setAll: (state, data)=>{
    if(data != undefined || data != null){
      state.all = data
    }
  }
};

export const actions = {
  async getAllParameters({commit, state},data){
    commit('setLoading', 1, { root: true })
    try {
      commit('setLoading', -1, { root: true })
      let response = await state.parametro.all(data)
      commit('setAll', response.data)
    } catch(err) {
      console.error(err)
      localStorage.setItem('status', false)
      router.push('/login');
    }
  }
};
